export const productTypes = {
  will: "will",
  willFree: "will_free",
  prenup: "prenup",
  futurePow: "future_pow",
  coop: "coop",
  favored: "favored",
  undividedEstateAgreement: "undivided_estate_agreement",
  pow: "pow",
  buyerAdvice: "buyer_advice",
  willContents: "will_contents",
  promissoryNote: "promissory_note",
  deedOfGift: "deed_of_gift",
  // "existing_documen" (missing "t") is the established wire/DB value — do not "fix" it
  existingDocument: "existing_documen",
  guidance: "guidance",
  willChild: "will_child",
  custom: "custom",
  propertyDivisionAgreement: "property_division_agreement",
  deedProperty: "deed_property",
  inheritanceAdvance: "inheritance_advance",
  inheritanceWaiver: "inheritance_waiver",
  childSupportAgreement: "child_support_agreement",
  togethernessAgreement: "togetherness_agreement",
  spousalSupportAgreement: "spousal_support_agreement",
  prenuptialExit: "prenuptial_exit",
  deedDivorce: "deed_divorce",
  prenuptialPension: "prenuptial_pension",
  advisorAgreement: "advisor_agreement",
  applicationToAgricultureAgency: "application_to_agriculture_agency",
  applicationToCivilAgency: "application_to_civil_agency",
  debitorShift: "debitor_shift",
  familyTrade: "family_trade",
  priceNegotiation: "price_negotiation",
  privateTrade: "private_trade",
  transferAgreement: "transfer_agreement",
  probateCertificate: "probate_certificate",
} as const;
